// extracted by mini-css-extract-plugin
module.exports = {"search-select":"_1PsVL","searchLabel":"sBpaf"};